<template>
  <div class="b-highlight">
    <div class="b-highlight__picture">
      <Anchor
        v-if="item.link"
        :item="item.link"
        :hide-text="true"
        class="btn btn-link btn-icon-end btn-forward">
        <PictureTag
          v-if="item.image"
          :image="item.image"
          :image-mobile="item.imageMobile"
          :breakpoint="991" />
      </Anchor>
      <div v-else>
        <PictureTag
          v-if="item.image"
          :image="item.image"
          :image-mobile="item.imageMobile"
          :breakpoint="991" />
      </div>
    </div>

    <div class="b-highlight__info">
      <div class="b-highlight__title">
        {{ item.title }}
      </div>
      <div class="b-highlight__description" v-html="item.summary"></div>
      <div class="b-highlight__link">
        <Anchor
          v-if="item.link"
          :item="item.link"
          class="btn btn-link btn-icon-end btn-forward strong">
          <i class="icon-arrow-long-right"></i>
        </Anchor>
      </div>
    </div>
  </div>
</template>

<script>
import Anchor from './common/Anchor.vue'
import PictureTag from './common/Picture.vue'

export default {
  components: { Anchor, PictureTag },
  props: {
    item: {
      required: true,
      type: Object,
    },
  },
}
</script>
